import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import Typography from "ds/components/Typography";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import Box from "ds/components/Box";
import NavigationBarActionKeys from "components/Run/elements/NavigationBar/ActionKeys";

import styles from "./styles.module.css";

const MainNavigationKeyboardShortcutsDrawer = createDrawer(() => {
  // Define all run shortcuts based on actual useRunShortcut usage in the codebase
  const runShortcuts = [
    // Navigation shortcuts (from NavigationBar)
    { action: "Previous run", shortcut: "left" },
    { action: "Next run", shortcut: "right" },

    // Run action shortcuts (from actual useRunShortcut implementations)
    { action: "Confirm run", shortcut: "mod+Alt+Enter" },
    { action: "Discard run", shortcut: "mod+Alt+X" },
    { action: "Retry run", shortcut: "mod+Alt+R" },
    { action: "Stop run", shortcut: "mod+Alt+S" },
    { action: "Promote run", shortcut: "mod+Alt+G" },
    { action: "Prioritize/De-prioritize run", shortcut: "mod+Alt+h" },
    { action: "Perform task again", shortcut: "mod+Alt+P" },

    // Review shortcuts (from ApprovalPoliciesEntry)
    { action: "Approve run", shortcut: "mod+Alt+A" },
    { action: "Reject run", shortcut: "mod+Alt+Q" },
  ];

  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Keyboard shortcuts" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight>
        <Typography tag="h3" variant="p-t7">
          Run view keyboard shortcuts
        </Typography>

        <Box className={styles.drawerContent} margin="large 0" gap="medium">
          <table>
            <thead>
              <tr>
                <th>
                  <Typography tag="span" variant="p-t7">
                    Action
                  </Typography>
                </th>
                <th>
                  <Typography tag="span" variant="p-t7">
                    Shortcut
                  </Typography>
                </th>
              </tr>
            </thead>
            <tbody>
              {runShortcuts.map((shortcut, index) => (
                <tr key={index}>
                  <td>
                    <Typography tag="span" variant="p-body3">
                      {shortcut.action}
                    </Typography>
                  </td>
                  <td>
                    <NavigationBarActionKeys code={shortcut.shortcut} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        <Typography tag="p" variant="p-body3" color="primary">
          <strong>Note:</strong> Some shortcuts may not be available depending on the current run
          state and your permissions.
        </Typography>
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showKeyboardShortcutsDrawer = createDrawerTrigger(
  MainNavigationKeyboardShortcutsDrawer
);
